import React from 'react';
import { Button } from '@chakra-ui/react';

const CancelButton = ({ onOpen, msg, isDisabled = false, id }) => {
  return (
    <Button
      id={id || ''}
      isDisabled={isDisabled}
      w="170px"
      fontSize="14px"
      py="22px"
      fontWeight="400"
      mb="30px"
      onClick={onOpen}
      colorScheme="red"
      mr="10px"
    >
      {msg}
    </Button>
  );
};

export default CancelButton;
